import React from 'react';

interface MFAStatusBadgeProps {
  mfaRequired: boolean;
  mfaSetupComplete?: boolean;
  size?: 'sm' | 'md' | 'lg';
}

const MFAStatusBadge: React.FC<MFAStatusBadgeProps> = ({
  mfaRequired,
  mfaSetupComplete = false,
  size = 'md'
}) => {
  const sizeClasses = {
    sm: 'px-2 py-0.5 text-xs',
    md: 'px-2.5 py-1 text-xs',
    lg: 'px-3 py-1.5 text-sm'
  };

  if (!mfaRequired) {
    return (
      <span className={`inline-flex items-center ${sizeClasses[size]} font-medium rounded-full bg-gray-100 text-gray-800`}>
        <svg className="w-3 h-3 mr-1" fill="currentColor" viewBox="0 0 20 20">
          <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clipRule="evenodd" />
        </svg>
        Not Required
      </span>
    );
  }

  if (!mfaSetupComplete) {
    return (
      <span className={`inline-flex items-center ${sizeClasses[size]} font-medium rounded-full bg-yellow-100 text-yellow-800`}>
        <svg className="w-3 h-3 mr-1 animate-pulse" fill="currentColor" viewBox="0 0 20 20">
          <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-12a1 1 0 10-2 0v4a1 1 0 00.293.707l2.828 2.829a1 1 0 101.415-1.415L11 9.586V6z" clipRule="evenodd" />
        </svg>
        Required - Pending
      </span>
    );
  }

  return (
    <span className={`inline-flex items-center ${sizeClasses[size]} font-medium rounded-full bg-green-100 text-green-800`}>
      <svg className="w-3 h-3 mr-1" fill="currentColor" viewBox="0 0 20 20">
        <path fillRule="evenodd" d="M2.166 4.999A11.954 11.954 0 0010 1.944 11.954 11.954 0 0017.834 5c.11.65.166 1.32.166 2.001 0 5.225-3.34 9.67-8 11.317C5.34 16.67 2 12.225 2 7c0-.682.057-1.35.166-2.001zm11.541 3.708a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
      </svg>
      Required - Active
    </span>
  );
};

export default MFAStatusBadge;
